import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { PAGES } from '../pages/ContentPage';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-black border-t border-black/10 dark:border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold bg-gradient-to-r from-emerald-500 to-cyan-500 dark:from-emerald-400 dark:to-cyan-400 bg-clip-text text-transparent mb-4">
              Emboscale
            </div>
            <p className="text-gray-600 dark:text-gray-400 max-w-md">
              The Factory Agent — plans, simulates, and programs your factory,
              end to end. Verified at every step.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-gray-900 dark:text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <a href="#pipeline" className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                  Pipeline
                </a>
              </li>
              <li>
                <a href="#capabilities" className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                  Capabilities
                </a>
              </li>
              <li>
                <a href="#verification" className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                  Verification
                </a>
              </li>
              <li>
                <a href="#cta" className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                  Book a demo
                </a>
              </li>
            </ul>
          </div>

          {/* Learn */}
          <div>
            <h4 className="text-gray-900 dark:text-white font-semibold mb-4">Learn</h4>
            <ul className="space-y-2">
              {PAGES.map((p) => (
                <li key={p.path}>
                  <Link to={p.path} className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                    {p.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gray-900 dark:text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="mailto:contact@emboscale.com" className="text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-black/10 dark:border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-gray-500 text-sm mb-4 md:mb-0">
            <span>© {currentYear} Emboscale. All rights reserved.</span>
            <Link to="/privacy" className="hover:text-emerald-400 transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-emerald-400 transition-colors duration-200">
              Terms of Use
            </Link>
          </div>

          <a
            href="mailto:contact@emboscale.com"
            className="flex items-center gap-2 text-gray-600 hover:text-emerald-600 dark:text-gray-400 dark:hover:text-emerald-400 transition-colors duration-200"
          >
            <Mail size={18} />
            contact@emboscale.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
